import React, { useState } from 'react';
import { styled } from 'linaria/react';
import { ReactComponent as Check } from '../assets/Check.svg';


const ColorButton3D = styled('div')`
  display: flex;
  align-items: center;
  gap: 7px;
  border: 1.5px solid transparent;
  cursor: pointer;
  background: #fff;
  position: relative;
  padding: 4px 0 4px 8px;
  height: 40px;
  &.active {
    border: 1.5px dotted #ccc;
    border-radius: 20px;
    background: #fff;
    display: flex;
    align-items: center;
    padding: 4px 14px 4px 8px;
  }

  @media screen and (max-width: 1023px) {
    &.active {
      margin: 0 0 0 0;
    }
  }
`

const ColorButton3DBackground = styled('div')`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1.5px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

`

const ColorButton3DText = styled('span')`
  font-size: 16px;
  font-weight: 500;
  color: #222;
  margin-left: 2px;
  z-index: -1;
  width: 0;
  &.active {
    width: auto;
    z-index: 0;
  }

  @media screen and (max-width: 1023px) {
    &.active {
      width: max-content;
    }
  }
`

const ColorButton3DCheckmark = styled('div')`
  background: transparent;
  padding: 3px;
  border-radius: 999px;
  width: 25px;
  height: 25px;
  justify-content: center;
  align-items: center;
  display: none;
  &.inverted {
    svg {
      path {
        fill: transparent;
        stroke: #fff;
      }
      use {
        fill: transparent;
        stroke: #fff;
      }
    }
  }
  &.active {
    display: flex;
  }
  svg {
    path {
      fill: transparent;
      stroke: #000;
    }
    use {
      fill: transparent;
      stroke: #000;
    }
  }
`

export const Color3D = (props) => {
  const [hovered, setHovered] = useState(false);

  let classNames = ''

  if (props.color.inverted === true) {
    classNames += 'inverted';
  }

  if (props.active) {
    classNames += ' active';
  }

  return <>
  <ColorButton3D onMouseEnter={() => setHovered(true)}
                 onMouseLeave={() => setHovered(false)}
                 className={`${hovered || props.active ? "active" : ""}`}
  onClick={props.onClick}>
    {props.color.color ? <ColorButton3DBackground style={{background: props.color.color}}><ColorButton3DCheckmark className={classNames}><Check></Check></ColorButton3DCheckmark></ColorButton3DBackground> : <ColorButton3DBackground style={{background: 'transparent', border: '1px solid #000'}}>
      <ColorButton3DCheckmark className={classNames}>
        <Check></Check>
      </ColorButton3DCheckmark>
    </ColorButton3DBackground>}
    <ColorButton3DText className={`${hovered || props.active ? "active" : ""}`}>{props.color.name}</ColorButton3DText>
  </ColorButton3D>
  </>;
};
